export default function columns(t) {
  return [
    { title: t('general.before-dueDate'), field: 'daysBeforeExpiration' },
    {
      title: t('general.percentage-discount'),
      field: 'discountPercentage',
    },
  ];
}
